var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-appfooter"},[_c('wrap-container',{staticClass:"w100"},[_c('footer',[_c('p',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.footerText),expression:"footerText"}]})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }